import { styled, css } from '$utils/theme'
import { rem } from 'polished'
import { Link } from '$views/components/Link'

const iconList = require('$images/rightArrow.png')
const iconCard = require('$images/checkList.png')

interface Props {
  card?: boolean
  idList?: number
  length?: number
  visible?: boolean
}

export const StyleUnorderedList = styled.ul.attrs({})<Props>`
  list-style-image: url(${p => (p.card ? iconCard : iconList)});
  position: relative;
  padding-inline-start: 1.2rem;
  ${p =>
    p.card &&
    p.theme.media.desktop`
      padding-inline-start: 1.5rem;
      padding-bottom: ${rem(p.theme.sizes.mini)}
      display: grid;
      row-gap: 1rem;
  `} ${p =>
    p.card &&
    p.theme.media.onlyMobile`
      padding-inline-start: 1.5rem;
      display: block;
  `};
`

export const StyledList = styled.li.attrs({})<Props>`
  padding-left: 5px;
  display: list-item;

  ${p =>
    p.idList > 7 &&
    p.card &&
    p.visible &&
    css`
      display: list-item;
    `};
  ${p =>
    p.idList > 7 &&
    p.card &&
    !p.visible &&
    css`
      display: none;
    `};

  ${p =>
    p.idList > 2 &&
    p.visible &&
    p.card &&
    p.theme.media.onlyMobile`
      display: list-item;
    `};
  ${p =>
    p.idList > 2 &&
    !p.visible &&
    p.card &&
    p.theme.media.onlyMobile`
      display: none;
    `};
  ${p =>
    p.card &&
    p.theme.media.onlyMobile`
    padding-bottom: ${rem(p.theme.sizes.mini)}
  `};
`

export const StyledLink = styled(Link).attrs({})<Props>`
  ${p =>
    p.length > 8 &&
    !p.visible &&
    `
      &:after {
        content: 'Ver toda la formacion (${p.length - 8})';
      }
    `}
  ${p =>
    p.length > 8 &&
    p.visible &&
    `
      &:after {
        content: 'Ver menos';
      }
    `}
  ${p =>
    p.length > 3 &&
    !p.visible &&
    p.theme.media.onlyMobile`
        &:after {
          content: 'Ver toda la formacion (${p.length - 3})';
        }
      `}
  ${p =>
    p.length > 3 &&
    p.visible &&
    p.theme.media.onlyMobile`
      &:after {
        content: 'Ver menos';
      }
    `}
`



// WEBPACK FOOTER //
// ./src/views/components/List/UnordererList/UnorderedList.style.ts